import * as React from "react";

import { AxiosResponse, isAxiosError } from "axios";
import { Result } from "../types/Result";
import { toast } from "react-toastify";

function usePost<T = null>(successMessage?: string, showError = true) {
  const [result, setResult] = React.useState<Result<T> | null>(null);
  const [waiting, setWaiting] = React.useState(false);
  const post = (promise: Promise<AxiosResponse<Result<T>>>) => {
    setWaiting(true);
    return promise
      .then((r) => {
        if (r.data) {
          setResult(r.data);
        } else {
          setResult({
            data: null,
            errors: [],
            isSuccess: true,
            statusCode: "typeError",
          });
        }
        if (successMessage) {
          toast.success(successMessage);
        }
        return r;
      })
      .catch((e) => {
        if (
          isAxiosError(e) &&
          e.response?.data &&
          Array.isArray(e.response?.data.errors)
        ) {
          if (e.response?.data.errors.length && showError) {
            for (const error of e.response?.data.errors) {
              toast.error(error);
            }
          }
          console.error(e);
          setResult(e.response?.data);
        } else if (e instanceof TypeError) {
          setResult({
            data: null,
            errors: [e.message],
            isSuccess: false,
            statusCode: "typeError",
          });
        } else if (e instanceof Error) {
          setResult({
            data: null,
            errors: [e.message],
            isSuccess: false,
            statusCode: "typeError",
          });
        }
        throw e;
      })
      .finally(() => {
        setWaiting(false);
      });
  };
  return { post, result, waiting };
}

export default usePost;
